import * as Models from '@models';

export const modelsMap = new Map<string, any>([
  ['users', Models.User],
  ['conventions', Models.Convention],
  ['contracts', Models.Contract],
  ['purchase-requests', Models.PurchaseRequest],
  ['invoices', Models.Invoice],
  ['work-orders', Models.WorkOrder],
  ['revenues', Models.Revenue],
  ['entry-goods', Models.EntryGoods],
]);
